import { useState } from 'react';

const mediaItems = [
  {
    id: 1,
    title: '悬疑片单：十部让你彻夜难眠的反转神作',
    desc: '从经典到新片，盘点近年来最令人惊艳的悬疑电影',
    duration: '15:28',
    views: '12.8万',
    imageSeq: 'media-01',
  },
  {
    id: 2,
    title: '科幻电影视觉效果进化史',
    desc: '从模型特效到数字CG，科幻电影的视觉革命之路',
    duration: '22:10',
    views: '9.3万',
    imageSeq: 'media-02',
  },
  {
    id: 3,
    title: '华语文艺片十佳推荐',
    desc: '那些拍进心里的华语文艺电影，每一部都值得细细品味',
    duration: '18:45',
    views: '7.6万',
    imageSeq: 'media-03',
  },
  {
    id: 4,
    title: '动画电影幕后制作揭秘',
    desc: '走进动画工作室，看一部动画电影是如何诞生的',
    duration: '25:30',
    views: '6.1万',
    imageSeq: 'media-04',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">影视解说</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">精选影视解说与影评推荐，帮你发现好电影</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MediaCard({ item }: { item: typeof mediaItems[0] }) {
  const [imgError, setImgError] = useState(false);

  const imageUrls: Record<string, string> = {
    'media-01': 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20film%20noir%20scene%20with%20shadowy%20detective%20figure%20standing%20under%20street%20lamp%20in%20rain%20atmospheric%20cinematography%20deep%20contrast%20lighting%20warm%20golden%20and%20dark%20tones%20suspenseful%20mood&width=800&height=500&seq=media-01&orientation=landscape',
    'media-02': 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20city%20with%20flying%20vehicles%20and%20holographic%20displays%20neon%20lights%20reflecting%20on%20glass%20buildings%20cinematic%20wide%20angle%20epic%20cyberpunk%20aesthetic%20dramatic%20lighting%20stunning%20visual&width=800&height=500&seq=media-02&orientation=landscape',
    'media-03': 'https://readdy.ai/api/search-image?query=Poetic%20Chinese%20landscape%20with%20misty%20mountains%20and%20quiet%20lake%20at%20dawn%20soft%20diffused%20light%20artistic%20composition%20contemplative%20atmosphere%20film%20grain%20texture%20warm%20subtle%20tones%20cinematic%20beauty&width=800&height=500&seq=media-03&orientation=landscape',
    'media-04': 'https://readdy.ai/api/search-image?query=Animation%20studio%20workspace%20with%20drawing%20table%20and%20warm%20lamp%20light%20character%20sketches%20on%20walls%20creative%20atmosphere%20behind%20the%20scenes%20film%20production%20cozy%20artistic%20environment%20storyboard%20panels&width=800&height=500&seq=media-04&orientation=landscape',
  };

  return (
    <a href="#cards" className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
      <div className="relative aspect-[16/10] overflow-hidden">
        {!imgError ? (
          <img
            src={imageUrls[item.imageSeq]}
            alt={item.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-film-line text-3xl text-foreground-400"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-3 left-3 right-3 flex items-center gap-3">
          <div className="flex items-center gap-1 text-background-50 text-xs bg-background-950/50 px-2 py-1 rounded-md">
            <i className="ri-play-fill text-sm"></i>
            <span className="whitespace-nowrap">{item.duration}</span>
          </div>
          <div className="flex items-center gap-1 text-background-50 text-xs bg-background-950/50 px-2 py-1 rounded-md">
            <i className="ri-eye-line text-sm"></i>
            <span className="whitespace-nowrap">{item.views}</span>
          </div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
        <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
      </div>
    </a>
  );
}